import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import mapProduct from './mapProduct';
import Product from './Product';
import ProductErrorResponse from './ProductErrorResponse';

export interface Result {
	product: Product;
}

export default function findProduct(client: ApiClient, id: string): Promise<Result> {
	return client
		.fetch(parseTemplate('products/{id}').expand({ id }))
		.then((response) => response.json())
		.then((response) => ({
			product: mapProduct(response.product),
		}))
		.catch((response) => ApiClientErrorResponse.wrapError(response, ProductErrorResponse));
}
